import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import SelectOptionSingleButton from "components/app/function/SelectOptionSingleButton";
import TextInput from "components/app/function/TextInput";
import { Button } from "components/ui/button";
import { Label } from "components/ui/label";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Textarea } from "components/ui/textarea";
import { Loader, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { AppLog } from "services";
import appStore from "store/appStore";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";
import SkeletonEditMusicInformation from "./skeleton/SkeletonEditMusicInformation";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { useAppSelector } from "store/store";
import axios from "axios";
import SelectOption from "components/app/function/SelectOption";

interface DialogProps {
  onUploadSuccess: ({ res, name }: { res: any; name: string }) => void;
  musicItem?: any;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  musicGenresDatas: any[] | null;
  musicAlbumDatas: any;
  itemMusicAlbumClicked: any;
}

const ffmpeg = new FFmpeg();

export default function DialogEditAndAddMusic({
  onUploadSuccess,
  musicItem,
  isDialogOpen,
  setIsDialogOpen,
  musicGenresDatas,
  musicAlbumDatas,
  itemMusicAlbumClicked,
}: DialogProps) {
  const { token } = useAppSelector((state) => state.auth);
  const [updateDatas, setUpdateDatas] = useState<any>(null);
  const { showDialogConfirm } = appStore();
  const [loadingSubmitUpdate, setLoadingSubmitUpdate] = useState<boolean>(false);
  const [loadingSubmitDelete, setLoadingSubmitDelete] = useState<boolean>(false);
  const [initLoading, setinitLoading] = useState<boolean>(false);
  const [initUploadMusicLoading, setInitUploadMusicLoading] = useState<boolean>(false);
  const [processingUpLoading, setProcessingUpLoading] = useState(false);
  const selectedFile = useRef<any>();
  const [soundDuration, setSoundDuration] = useState<number | null>(null);
  const [outputUrl, setOutputUrl] = useState<string | null>(null);
  const [outputFile, setOutputFile] = useState<File | any>(null);
  let storageHostClusterId = "";
  let hostName = "";
  let url: string = "";
  let uploadFile: any = "";
  let musicUrl: string = "";
  let musicSrc: string = "";

  useEffect(() => {
    if (!updateDatas) {
      const loadFFmpeg = async () => {
        if (!ffmpeg.loaded) {
          setInitUploadMusicLoading(true);
          await ffmpeg.load();
          setInitUploadMusicLoading(false);
        }
      };
      loadFFmpeg();
    }
  }, [updateDatas]);

  const handleUpload = async () => {
    url = RouteApi.getStorageHostCluster;
    url += `token=${token}`;

    const response = await RequestApi(url, {
      data: {
        token,
        file_size: outputFile?.size,
      },
    });

    if (response.status === "success") {
      storageHostClusterId = response.storage_host_cluster.id;
      hostName = response.storage_host_cluster.host_name;
    } else {
      AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
    }

    let url1 = `${hostName}/api-mobile-flipflop/v1/submit-upload-files?`;
    url1 += `token=${token}`;
    url1 += `&storage_host_cluster_id=${storageHostClusterId}`;

    const formdata = new FormData();
    formdata.append("file_music", outputFile);

    const reqOptions = {
      url: url1,
      method: "POST",
      data: formdata,
    };
    await axios
      .request(reqOptions)
      .then((res) => {
        uploadFile = res.data.upload_files;
        return res;
      })
      .catch((err) => {
        console.log(JSON.stringify(err));
      });

    musicUrl = uploadFile[0]["attachment_url"];
    musicSrc = uploadFile[0]["attachment_source"];
  };

  const initEditMusicInformation = async () => {
    setinitLoading(true);
    try {
      let url: string = "";
      url = RouteApi.getMusicInformation;
      url += `token=${Service.token}`;
      const data = {
        sound_id: musicItem?.sound_id || "",
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setUpdateDatas(responses.music);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[initEditMusicInformation]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setinitLoading(false);
    }
  };

  useEffect(() => {
    if (isDialogOpen && musicItem) {
      initEditMusicInformation();
    } else {
      setUpdateDatas(null);
    }
  }, [isDialogOpen, musicItem]);

  const handleClear = () => {
    setOutputUrl(null);
    setOutputFile(null);
    setSoundDuration(null);
    hostName = "";
    url = "";
    uploadFile = "";
    musicUrl = "";
    musicSrc = "";
  };

  const onSubmitInsertUserSound = async () => {
    setLoadingSubmitUpdate(true);
    if (!updateDatas.sound_url && outputFile) {
      await handleUpload();
    }
    try {
      let url: string = "";
      url = RouteApi.submitInsertMusicInformation;
      url += `token=${Service.token}`;
      const data = {
        music_album_id: updateDatas?.music_album_id ?? itemMusicAlbumClicked?.id,
        sound_title: updateDatas?.sound_title || "",
        sound_album: updateDatas?.sound_album ?? itemMusicAlbumClicked?.name,
        sound_singer: updateDatas?.sound_singer || "",
        sound_author: updateDatas?.sound_author || "",
        sound_genres: updateDatas?.sound_genres || "",
        // inactived: updateDatas?.inactived || "",
        hashtag: updateDatas?.hashtag || "",
        commercial_price: updateDatas?.commercial_price || "",
        sound_id: "",
        sound_duration: soundDuration,
        sound_url: musicUrl,
        sound_src: musicSrc,
        provider_storage_host_id: storageHostClusterId,
      };
      console.log("dataAdd", data);

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            console.log("responsesAdd", responses);
            onUploadSuccess({
              res: responses.music,
              name: "insert",
            });
            setIsDialogOpen(false);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[onSubmitInsertUserSound]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingSubmitUpdate(false);
    }
  };

  const onSubmitUpdateUserSound = async () => {
    setLoadingSubmitUpdate(true);
    if (!updateDatas.sound_url && outputFile) {
      await handleUpload();
    }
    try {
      let url: string = "";
      url = RouteApi.submitUpdateMusicInformation;
      url += `token=${Service.token}`;
      const data = {
        music_album_id: updateDatas.music_album_id || musicItem.music_album_id,
        sound_id: updateDatas.sound_id,
        sound_title: updateDatas.sound_title,
        sound_album: updateDatas?.sound_album,
        sound_singer: updateDatas.sound_singer,
        sound_author: updateDatas.sound_author,
        inactived: updateDatas?.inactived,
        sound_genres: updateDatas.sound_genres,
        hashtag: updateDatas.hashtag,
        commercial_price: updateDatas?.commercial_price || "",
        sound_duration: soundDuration,
        sound_url: musicUrl,
        sound_src: musicSrc,
        provider_storage_host_id: storageHostClusterId,
      };
      console.log("dataUPdate", data);

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            console.log("responsesUPdate", responses);

            onUploadSuccess({
              res: responses.music,
              name: "insert",
            });
            setIsDialogOpen(false);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[onSubmitUpdateUserSound]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingSubmitUpdate(false);
    }
  };

  const onSubmitDeleteUserSound = async () => {
    setLoadingSubmitDelete(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteMusicInformation;
      url += `token=${Service.token}`;
      const data = {
        sound_id: musicItem.sound_id,
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            onUploadSuccess({
              res: responses.music,
              name: "delete",
            });
            setIsDialogOpen(false);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteUserSound]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingSubmitDelete(false);
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    selectedFile.current = event.target.files?.[0];
    event.target.value = "";
    console.log("event.target.files", event.target.files?.[0]);

    if (selectedFile.current) {
      setProcessingUpLoading(true);
      try {
        // Convert file to ArrayBuffer and write it to FFmpeg FS
        const fileBuffer = await selectedFile.current.arrayBuffer();
        await ffmpeg.writeFile(selectedFile.current.name, new Uint8Array(fileBuffer));

        // Execute FFmpeg command to convert to m4a format
        await ffmpeg.exec(["-i", selectedFile.current.name, "-vn", "-acodec", "aac", "output.m4a"]);

        const data: any = await ffmpeg.readFile("output.m4a");
        const audioBlob = new Blob([data.buffer], { type: "audio/m4a" });
        const audioUrl = URL.createObjectURL(new Blob([data.buffer], { type: "audio/m4a" }));
        getMediaDuration(audioUrl);
        const audioFile = new File([audioBlob], "output.m4a", {
          type: "audio/m4a",
        });

        setOutputFile(audioFile);
        setOutputUrl(audioUrl);
        setProcessingUpLoading(false);
      } catch (error) {
        // Handle errors
        console.error("Error processing file:", error);
        setProcessingUpLoading(false);
      }
    }
  };

  const getMediaDuration = (url: string) => {
    const media: any = document.createElement("audio");
    media.src = url;

    media.addEventListener("loadedmetadata", () => {
      setSoundDuration(media.duration.toFixed(0));
    });
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent isShowBtnXClose={false} className="flex flex-col h-[calc(100vh-80px)] justify-between custom-dialog-class lg:max-w-[1000px] md:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>{musicItem ? "Edit Music Information" : "Add New Music"}</DialogTitle>
          <DialogDescription>Input the Title, Singer, Author, Genres, and Other Information, click "Save" when you finished.</DialogDescription>
          <div
            className="flex bg-gray-200 h-[28px] justify-center rounded-full w-[28px] absolute cursor-pointer dark:bg-accent items-center right-4 top-1 z-40"
            onClick={() => {
              setIsDialogOpen(false);
              handleClear();
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="h-[calc(100vh-80px)] w-full pr-[20px] space-y-2">
          {initLoading ? (
            <SkeletonEditMusicInformation />
          ) : (
            <div className="pb-8">
              <div className="mb-2 mx-2">
                {!updateDatas?.sound_url ? (
                  <>
                    <Label className="">Upload File (Video or Music)</Label>
                    <div className="flex items-center mt-2 space-x-4">
                      {!outputUrl && (
                        <Button variant="secondary" disabled={updateDatas?.sound_url ? true : false || processingUpLoading || outputUrl ? true : false}>
                          <Label className="cursor-pointer" htmlFor="file">
                            {processingUpLoading ? "Processing..." : "Choose file"}
                          </Label>
                        </Button>
                      )}
                      {outputUrl && <audio controls src={outputUrl} className="py-1" />}
                      {outputUrl && (
                        <Button disabled={loadingSubmitUpdate} variant="destructive" className="" onClick={handleClear}>
                          Change
                        </Button>
                      )}
                    </div>
                    <input id="file" type="file" onChange={handleFileChange} hidden accept="audio/*, video/*" />
                  </>
                ) : (
                  <div className="grid grid-cols-2">
                    <div className="w-full">
                      <Label className="">Music</Label>
                      <div className="me-2">
                        <audio controls src={updateDatas?.sound_url} className="bg-background w-full py-1" />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-12">
                <div className="col-span-6 mx-2 space-y-2">
                  <Label className="">Title</Label>
                  <TextInput
                    value={updateDatas?.sound_title}
                    onChange={(event) => {
                      setUpdateDatas((prev: any) => ({
                        ...prev,
                        sound_title: event.target.value,
                      }));
                    }}
                  />
                </div>
                <div className="col-span-3 mx-2 space-y-2">
                  <Label className="">Price</Label>
                  <TextInput
                    value={updateDatas?.commercial_price}
                    onChange={(event) => {
                      setUpdateDatas((prev: any) => ({
                        ...prev,
                        commercial_price: event.target.value,
                      }));
                    }}
                  />
                </div>

                {musicItem && (
                  <div className="col-span-3 mx-2 space-y-2">
                    <Label className="">Inactive</Label>
                    <SelectOption
                      value={updateDatas?.inactived}
                      item={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      onValueChange={(value) => {
                        setUpdateDatas((prev: any) => ({
                          ...prev,
                          inactived: value,
                        }));
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="grid grid-cols-2">
                <div className="mt-2 mx-2 space-y-2">
                  <Label className="">Singer</Label>
                  <TextInput
                    value={updateDatas?.sound_singer}
                    onChange={(event) => {
                      setUpdateDatas((prev: any) => ({
                        ...prev,
                        sound_singer: event.target.value,
                      }));
                    }}
                  />
                </div>

                <div className="mt-2 mx-2 space-y-2">
                  <Label className="">Author</Label>
                  <TextInput
                    value={updateDatas?.sound_author}
                    onChange={(event) => {
                      setUpdateDatas((prev: any) => ({
                        ...prev,
                        sound_author: event.target.value,
                      }));
                    }}
                  />
                </div>
              </div>

              <div className="mt-2 mx-2 space-y-2">
                <Label className="">Genres</Label>
                <SelectOptionSingleButton
                  datas={musicGenresDatas?.map((item: any) => item.name)}
                  value={updateDatas?.sound_genres}
                  onValueChange={(value) => {
                    setUpdateDatas((prev: any) => ({
                      ...prev,
                      sound_genres: value,
                    }));
                  }}
                />
              </div>

              <div className="mt-2 mx-2 space-y-2">
                <Label className="">Album</Label>
                <SelectOptionSingleButton
                  datas={musicAlbumDatas?.data.map((item: any) => item.name)}
                  value={updateDatas?.sound_album || itemMusicAlbumClicked?.name}
                  onValueChange={(value) => {
                    const updateValue = musicAlbumDatas?.data.find((item: any) => item.name === value);

                    if (updateValue) {
                      setUpdateDatas((prev: any) => ({
                        ...prev,
                        sound_album: value,
                        music_album_id: updateValue.id,
                      }));
                    }
                  }}
                />
              </div>

              <div className="mt-2 mx-2 space-y-2">
                <Label className="">Hashtag</Label>
                <Textarea
                  value={updateDatas?.hashtag}
                  onChange={(event) => {
                    setUpdateDatas((prev: any) => ({
                      ...prev,
                      hashtag: event.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          )}
          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <DialogFooter className="flex justify-between gap-3">
          {musicItem ? (
            <>
              <Button
                disabled={loadingSubmitUpdate || loadingSubmitUpdate}
                onClick={() =>
                  showDialogConfirm({
                    title: "Delete",
                    message: "Do you want to delete ?",
                    onSubmit() {
                      onSubmitDeleteUserSound();
                    },
                  })
                }
                className="bg-red-600 border-0 text-white w-full focus:border-yellow-300 hover:bg-red-500 mt-3 outline-none"
              >
                {loadingSubmitDelete ? <Loader className="animate-spin" /> : "Delete"}
              </Button>

              <Button
                disabled={loadingSubmitUpdate || loadingSubmitUpdate}
                onClick={onSubmitUpdateUserSound}
                className="bg-blue-600 border-none text-white w-full hover:bg-blue-500 mt-3 outline-none"
              >
                {loadingSubmitUpdate ? <Loader className="animate-spin" /> : "Save"}
              </Button>
            </>
          ) : (
            <Button disabled={loadingSubmitUpdate || processingUpLoading} onClick={onSubmitInsertUserSound} className="bg-blue-600 text-white w-full hover:bg-blue-500 mt-3">
              {loadingSubmitUpdate ? <Loader className="animate-spin" /> : "Save"}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
